import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _define_property from "@swc/helpers/src/_define_property.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import Datalayer from "./data/Datalayer";
var Analytics = /*#__PURE__*/ function() {
    "use strict";
    function Analytics() {
        var _this = this;
        _class_call_check(this, Analytics);
        this.providers = [];
        this.eventsQueue = [];
        this.isInitialized = false;
        this.isPrepared = false;
        // Initialize the providers, effectively loading and executing their scripts
        this.initialize = function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _this.providers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var provider = _step.value;
                    provider.init();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            _this.isInitialized = true;
            if (_this.eventsQueue.length) {
                _this.eventsQueue.forEach(function(param) {
                    var data = param.data, providers = param.providers;
                    _this.sendEvent(data, providers);
                });
                _this.eventsQueue = [];
            }
        };
    }
    var _proto = Analytics.prototype;
    /**
   * Creates a list with all the providers that will be used for analytics,
   * used before loading the providers
   */ _proto.prepare = function prepare(providers) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = providers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var provider = _step.value;
                this.providers.push(provider);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.isPrepared = true;
    };
    /**
   * @deprecated Instead of this use sendCustomEvent (Which doesnt require to setup DLV in GTM)
   */ _proto.sendEvent = function sendEvent(data, providers) {
        var _this = this;
        return _async_to_generator(function() {
            var collection, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, provider, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, pr;
            return _ts_generator(this, function(_state) {
                // If the providers aren't initialized yet, queue these events to execute later
                if (!_this.isInitialized) {
                    _this.eventsQueue.push({
                        data: data,
                        providers: providers
                    });
                    return [
                        2
                    ];
                }
                collection = [];
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(_iterator = _this.providers[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        provider = _step.value;
                        if (!providers) {
                            if (provider.isActive) {
                                collection.push(provider.sendEvent(data));
                            }
                        } else {
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(_iterator1 = providers[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    pr = _step1.value;
                                    if (pr.name === provider.constructor.name) {
                                        collection.push(provider.sendEvent(data));
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return [
                    2,
                    Promise.all(collection)
                ];
            });
        })();
    };
    _proto.sendCustomEvent = function sendCustomEvent(analyticEventName, data) {
        var _this = this;
        return _async_to_generator(function() {
            var genericEventName, dlvGenericEventName, datalayerObject;
            return _ts_generator(this, function(_state) {
                genericEventName = "generic_analytics_event";
                dlvGenericEventName = "generic_analytics_event_data";
                datalayerObject = new Datalayer(genericEventName, _define_property({}, dlvGenericEventName, JSON.stringify({
                    analyticEventName: analyticEventName,
                    data: data
                })));
                return [
                    2,
                    _this.sendEvent(datalayerObject)
                ];
            });
        })();
    };
    return Analytics;
}();
export { Analytics as default };
